// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const LogoAthome: React.FC<SvgProps> = (props) => (
  <Svg {...props} viewBox="0 0 467.584 101.702">
    <title>logo_athome</title>
    <path
      fill="none"
      d="M34.6,108.716c0,4.377,4.169,7.945,11.173,7.945,6.739,0,10.994-2.066,10.994-6.262v-9.625a65.026,65.026,0,0,0-8.963-.83C38.571,99.944,34.6,101.122,34.6,108.716Z"
      transform="translate(-15.202 -29.449)"
    />
    <path
      fill="none"
      d="M272.835,75.687c-8.18,0-11.686,4.277-11.686,16.621v7.7c0,12.342,3.506,16.617,11.686,16.617,8.3,0,11.8-4.275,11.8-16.617v-7.7C284.636,79.964,281.13,75.687,272.835,75.687Z"
      transform="translate(-15.202 -29.449)"
    />
    <path
      fill="none"
      d="M463.392,83.476c0-4.377-4.17-7.944-11.172-7.944-6.741,0-10.994,2.734-10.994,11.267v4.586l8.962.383C459.417,91.768,463.392,91.073,463.392,83.476Z"
      transform="translate(-15.202 -29.449)"
    />
    <path
      fill="#c03"
      d="M272.835,61.042c-20.215,0-31.9,9.465-31.9,31.434v7.361c0,21.849,11.687,31.314,31.9,31.314,20.446,0,32.131-9.465,32.131-31.314V92.476C304.966,70.507,293.281,61.042,272.835,61.042Zm11.8,38.965c0,12.342-3.506,16.617-11.8,16.617-8.18,0-11.686-4.275-11.686-16.617v-7.7c0-12.344,3.506-16.621,11.686-16.621,8.3,0,11.8,4.277,11.8,16.621Z"
      transform="translate(-15.202 -29.449)"
    />
    <path
      fill="#c03"
      d="M208.639,61.042a46.622,46.622,0,0,0-19.98,4.674V29.449H168.327v47.8a170.981,170.981,0,0,0-21.985,19.014v11.57a142.883,142.883,0,0,1,21.985-16.615V129.4h20.332V79.505A34.424,34.424,0,0,1,202.1,76.349c6.543,0,8.763,2.455,8.763,11.1V129.4h20.33V87.218C231.189,71.792,227.1,61.042,208.639,61.042Z"
      transform="translate(-15.202 -29.449)"
    />
    <path
      fill="#c03"
      d="M113.5,117.247c-5.141,0-5.492-1.17-5.492-6.662v-33.3h19.569V62.8H108.01V45.97H87.681v64.849c0,14.723,6.192,20.332,20.329,20.332a32.721,32.721,0,0,0,23.009-9.951V109.665C121.826,117.6,113.5,117.247,113.5,117.247Z"
      transform="translate(-15.202 -29.449)"
    />
    <path
      fill="#c03"
      d="M441.226,103.038c3.019.246,7.38.4,9.611.4,18.926,0,31.949-2.9,31.949-20.666,0-12.373-11.58-21.734-30.449-21.734-21.033,0-31.08,10.282-31.08,33.537V98.2c0,24.418,9.23,32.949,33.651,32.949a109.083,109.083,0,0,0,24.216-2.951V114.917a183.768,183.768,0,0,1-23.281,1.6C441.755,116.515,441.24,111.491,441.226,103.038Zm0-16.239c0-8.533,4.253-11.267,10.994-11.267,7,0,11.172,3.567,11.172,7.944,0,7.6-3.975,8.292-13.2,8.292l-8.962-.383Z"
      transform="translate(-15.202 -29.449)"
    />
    <path
      fill="#c03"
      d="M390.69,61.042c-6.191,0-13.552,2.1-21.031,7.244-2.922-4.556-7.594-7.244-15.773-7.244a33.016,33.016,0,0,0-18.764,6.024L333.788,62.8H314.627v66.6h20.329V79.624c3.271-1.638,7.6-3.392,11.453-3.392,6.307,0,6.541,3.5,6.541,9.818V129.4h20.332V79.324a26.028,26.028,0,0,1,10.865-3.092c6.9,0,7.01,3.5,7.01,9.818V129.4h20.334V85.581C411.491,72.609,409.036,61.042,390.69,61.042Z"
      transform="translate(-15.202 -29.449)"
    />
    <path
      fill="#c03"
      d="M43.082,61.041a88.57,88.57,0,0,0-21.451,2.98V77.077a100.1,100.1,0,0,1,20.1-1.527c14.179,0,15.01,5.216,15.03,13.773a59.336,59.336,0,0,0-9.079-.818c-18.928,0-32.482,3.15-32.482,20.912,0,12.371,11.58,21.732,30.451,21.732A30.065,30.065,0,0,0,62.139,126.7l1.076,2.7h13.5l.014-35.4C76.733,69.57,67.5,61.041,43.082,61.041ZM56.764,110.4c0,4.2-4.255,6.262-10.994,6.262-7,0-11.173-3.568-11.173-7.945,0-7.594,3.974-8.772,13.2-8.772a65.026,65.026,0,0,1,8.963.83Z"
      transform="translate(-15.202 -29.449)"
    />
  </Svg>
);

LogoAthome.displayName = 'LogoAthome';

export default LogoAthome;
